import React, { Fragment, useState } from 'react';
import history from '../../../../history';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import Modal from '../../../../shared/components/Modal';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import ZoomInIcon from '@material-ui/icons/ZoomIn';


const ReactTableActions = ({ data, refresh,callbackUpdate }) => {

    const [isdelete, setIsdeleted] = useState(false);

    //console.log(refresh);
    const getPatient = (num) => {
        let data = { num_documento: num };
        fetch(process.env.REACT_APP_PUBLIC_URL + 'paciente/consultar', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(data)
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                console.log("UPDATINGPATIENT",data);
                //setPatient(data);                
                history.push({
                    pathname: process.env.PUBLIC_URL +'/pages/update-patient',
                    state: { patient: data }
                });
            }).catch((error) => {
                console.error('Error:', error);
            });
    }

    const onDelet = () => {

        setIsdeleted(false);
        //setIsLoading(true);
        //console.log(identificacion);
        let id = { id: data.data.original.id };        

        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'paciente/delete', {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(id)
            })
                .then(response => {
                                    
                    //refresh();
                    return response.json();
                })
                .then(data => {
                    resolve(true);
                })
                .catch((error) => {
                    resolve(error);
                });
        })
    }

    const watchPatientProfile = (id_patient) => {
        history.push({
            pathname: process.env.PUBLIC_URL +'/assitencial/patient-display-profile',
            state: {id_patient: id_patient}
        });  
    }

    return (<Fragment>
        <td role="cell">

            <Tooltip title="Editar">
                <IconButton aria-label="edit" onClick={() => {
                    //getPatient(data.data.original.num);
                    callbackUpdate(data.data.original)
                }}>
                    <EditOutlinedIcon />
                </IconButton>
            </Tooltip>                                
            <Tooltip title="Ver Perfil">
                <IconButton aria-label="edit" onClick={() => {
                    watchPatientProfile(data.data.original.num);
                }}>
                    <ZoomInIcon />
                </IconButton>
            </Tooltip>  
            <Modal
                color='warning'
                title='¿Esta seguro que desea eliminar este paciente?'
                modal={isdelete}
                onOk={onDelet}
                toggle={() => setIsdeleted(!isdelete)}
            />
        </td>
    </Fragment>)
}

export default ReactTableActions;